module.exports = __webpack_public_path__ + "media/images/ShoeYellow-0bf1a677.svg";